import React from 'react';
import { Chat } from './Chat';
import { ChatMessage, ReasoningPart, RedactedReasoningPart, TextPart, ToolCallPart } from './ChatTypes';
import { StreamedMessageContent } from './StreamedMessageContent';
import { StreamedToolCall } from './StreamedToolCall';

type AssitantMessagePart = TextPart | ReasoningPart | RedactedReasoningPart | ToolCallPart;

const MessagePartSwitch = React.memo(({ part, streaming }: { part: AssitantMessagePart, streaming: boolean }) => {
    switch (part.type) {
        case 'text':
            return <StreamedMessageContent content={part.text} complete={!streaming} />;
        case 'reasoning':
            return <StreamedMessageContent content={part.text} complete={!streaming} />;
        case 'redacted-reasoning':
            return <StreamedMessageContent content={'Redacted reasoning'} complete={!streaming} />;
        case 'tool-call':
            return <StreamedToolCall {...part} />;
        default:
            return null;
    }
});

export const AssistantMessage = React.memo(({ message }: { message: ChatMessage }) => {
    return <Chat.Message actor={<Chat.Seb />}>
        {message.content.map((p, i) => (
            <MessagePartSwitch key={[message.id, i].join('-')} part={p} streaming={message.streaming} />
        ))}
    </Chat.Message>;
});
